module.exports = __webpack_public_path__ + "static/img/item-rank.aa25f824.png";